module.exports = __webpack_public_path__ + "static/media/KAPorg.d1af488a.svg";